import { useApplicationsServiceApplicationsApplicationsList } from '@organization/api/queries'
import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { PermissionsSwitch } from '../../PermissionsSwitch'

type RolePermission = {
  value: string
  labels: Record<string, string>
}

export const TeamPermissions = () => {
  const { i18n } = useTranslation()

  const { data } = useApplicationsServiceApplicationsApplicationsList({})

  return data?.results
    ?.filter(({ instance_type }) => !!instance_type?.role_permissions?.length)
    .map(({ name, id, instance_type }) => (
      <Flex key={id} vertical gap={8} style={{ marginBottom: 10 }}>
        <Typography.Title level={4}>{name}</Typography.Title>

        <Flex vertical gap={16}>
          {instance_type?.role_permissions?.map(
            ({ labels, value }: RolePermission, idx: number) => (
              <PermissionsSwitch
                key={idx}
                name="application_permissions"
                label={labels[i18n.language]}
                applicationId={id}
                value={value}
              />
            )
          )}
        </Flex>
      </Flex>
    ))
}
